import React from "react"
import { Link, graphql } from "gatsby"
import { rhythm, scale } from "../utils/typography"
import styled from 'styled-components'
import Image from "gatsby-image"
import { MDXRenderer } from "gatsby-plugin-mdx"

import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Article from '../components/article'
import StripeSpacer from "../components/stripe-spacer"

const TagsSpan = styled.span`
  font-weight: bold;
  color: orange;
  a {
    margin-left: 8px;
    color: orange;
    box-shadow: none;
    &:hover {
      text-decoration: underline;
    }
  }
`

const MainBody = styled.section`
  p {
    margin: 28px 0px;
  }
  h1, h2, h3, h4, h5, h6 {
    margin-top: 24px;
    padding-top: 56px;
    /* margin-bottom: 40px; */
    display: flex;
    /* box-shadow: 0px 1px 0px 0px #ff6200; */
    &:before {
      content: '';
      border-left: solid 16px rgba(0,0,0, 0.1);
      padding-left: 16px;
      display: block;
      /* height: 30px; */
    }
  }
  .toc {
    // margin: 48px 0px;
    margin-top: 48px;
    /* margin-bottom: 16px; */
    padding: 24px;
    padding-bottom: 0px;
    /* padding: 4px 12px; */
    border: solid 16px #ededed;
    border-bottom: none;
    /* border-left: solid 8px lightgray; */
    /* background: rgba(0,0,0,0.1); */
    /* display: table; */
    &:before {
      content: 'TABLE OF CONTENTS';
      display: block;
      font-weight: bold;
      font-size: 13px;
      /* border-bottom: solid 24px #f5f5f5; */
      /* margin-bottom: 16px; */
      padding-bottom: 16px;
      font-family: 'Merriweather','Georgia',serif;
      font-weight: 900;
      color: #292442;
    }
  }
  .toc + ul {
    margin: 0px;
    padding: 24px;
    padding-left: 40px;
    border: solid 16px #ededed;
    border-top: dashed 1px lightgray;
    margin-bottom: 48px;
    li {
      margin: 0px;
      line-height: 40px;
    }
  }
  table {
    font-family: monospace;
    thead, tbody, tfoot {
      tr {
        td, th {
          &[align="left"] {
            text-align: left;
          }
          &[align="right"] {
            text-align: right;
          }
          &[align="center"] {
            text-align: center;
          }
        }
      }
    }
  }
  .footnotes {
    counter-reset: number 0;
    ol {
      li {
        display: flex;
        &:before {
          counter-increment: number 1;
          content: counter(number) "_" ;
          margin-right: 8px;
        }

        p {
          margin: 0px;
        }
        a {
          margin-left: 8px;
        }
      }
    }
  }
  .language-text {
    padding: 4px 7px;
  }
`

const BlogPostTemplate = ({ data, pageContext, location }) => {
  const post = data.mdx
  const siteTitle = data.site.siteMetadata.title
  const { previous, next, relatedPosts, thumbnailFluid, thumbnailPath } = pageContext

  return (
    <Layout location={location} title={siteTitle}>
      <SEO
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
        image={thumbnailPath}
        article={true}
        currentSlug={post.fields.slug}
      />
      <article>
        <header style={{
            paddingLeft: 24,
            borderLeft: 'solid 16px rgba(0,0,0, 0.1)',
            marginBottom: 80
          }}>
          <TagsSpan style={{ display: !post.frontmatter.tags && 'none' }}>#
            { post.frontmatter.tags && post.frontmatter.tags.map(tag => {
                return <Link key={tag} to={`/tag/${tag}/`}>{tag}</Link>
              })
            }
          </TagsSpan>
          <h1
            style={{
              marginTop: 16,
              marginBottom: 16,
              lineHeight: '55px'
            }}
          >
            {post.frontmatter.title}
          </h1>
          <p
            style={{
              ...scale(-1 / 5),
              display: `block`,
              // marginBottom: rhythm(1),
              marginTop: 13
            }}
          >
            {post.frontmatter.date}
          </p>
        </header>
        { thumbnailFluid && (
          <div
            className="img-wrapper"
            style={{
              // maxWidth: 800,
              margin: '40px auto'
            }}
          >
            <Image fluid={thumbnailFluid} />
          </div>
        )}
        {/* <MainBody dangerouslySetInnerHTML={{ __html: post.html }} />
        */}
        <MainBody>
          <MDXRenderer>{ post.body }</MDXRenderer>
        </MainBody>
        <hr
          style={{
            marginBottom: rhythm(1),
            marginTop: rhythm(3),
          }}
        />
        <footer>
          <Bio />
        </footer>
      </article>

      <nav>
        <ul
          style={{
            display: `flex`,
            flexWrap: `wrap`,
            justifyContent: `space-between`,
            listStyle: `none`,
            padding: 0,
          }}
        >
          <li>
            {previous && (
              <Link to={previous.fields.slug} rel="prev">
                ← {previous.frontmatter.title}
              </Link>
            )}
          </li>
          <li>
            {next && (
              <Link to={next.fields.slug} rel="next">
                {next.frontmatter.title} →
              </Link>
            )}
          </li>
        </ul>
      </nav>
      <StripeSpacer />
      <nav>
        <h4
          style={{
            borderBottom: 'dashed 2px lightgray',
            paddingBottom: 24
          }}
        >
          Related posts
        </h4>
        <ul
          style={{
            margin: '0px'
          }}
        >
          { relatedPosts.map(node => {
            const title = node.frontmatter.title || node.fields.slug
            const thumbnailFluid = node.frontmatter.thumbnail && node.frontmatter.thumbnail.childImageSharp.fluid
            return (
              <li
                style={{ listStyle: 'none' }}
                key={node.fields.slug}
              >
                  <Article
                    node={node}
                    title={title}
                    key={node.fields.slug}
                    thumbnailFluid={thumbnailFluid}
                  />
              </li>
            )
          })}
        </ul>
      </nav>
    </Layout>
  )
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    mdx(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      # html
      body
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
        tags
        thumbnail {
          childImageSharp {
            fluid(maxWidth: 1000) {
              ...fluidImageSchema
            }
          }
        }
      }
      fields {
        slug
      }
    }
  }
`
